/*eslint-disable*/

const DemographicsLegend = ({ isReversed = false, additionalText = null }) => (
  <div className="leaflet-biglayerpanel-demographics-layer-legend">
    {additionalText && <p style={{ fontSize: '80%' }}>{additionalText}</p>}
    {isReversed ? (
      <>
        <span className="leaflet-biglayerpanel-demographics-swatch q1" alt="color swatch for highest"></span>{' '}
        <label>Highest</label>
        <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q2" alt="color swatch for high"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q3" alt="color swatch for medium"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q4" alt="color swatch for low"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q5" alt="color swatch for lowest"></span>{' '}
        <label>Lowest</label>
        <br />
      </>
    ) : (
      <>
        <span className="leaflet-biglayerpanel-demographics-swatch q1" alt="color swatch for lowest"></span>{' '}
        <label>Lowest</label>
        <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q2" alt="color swatch for low"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q3" alt="color swatch for medium"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q4" alt="color swatch for high"></span> <br />
        <span className="leaflet-biglayerpanel-demographics-swatch q5" alt="color swatch for highest"></span>{' '}
        <label>Highest</label>
        <br />
      </>
    )}
  </div>
);

export const DemographicsLayerItem = ({
  id,
  label,
  isReversed = false,
  additionalText = null,
  isVisible = true,
  isActive = false,
  onSelect = () => {},
}) => (
  <div
    className={`leaflet-biglayerpanel-demographics-layer ${isVisible ? '' : 'collapsed'}`}
    data-demographics-polytype={id}
  >
    <div className="radio-item">
      <input
        type="radio"
        id={`leaflet-biglayerpanel-demographics-polytype-${id}`}
        name="leaflet-biglayerpanel-demographics-polytype"
        value={id}
        checked={isActive}
        onChange={() => onSelect(id)}
      />
      <label tabIndex="0" htmlFor={`leaflet-biglayerpanel-demographics-polytype-${id}`}>
        {label}
      </label>
    </div>
    {isActive && <DemographicsLegend isReversed={isReversed} additionalText={additionalText} />}
  </div>
);
